/* One quiet sentence in the place of a control or a failure: it states who can, and the reader has
   done nothing wrong. Same treatment as `OutsideEngagement` - a fact about access, not an alarm.
   Tokens only (ADR-0007). */
.note {
  margin: 0;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--line-2);
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.55;
  max-width: 92ch;
}
